import { arrConcat } from '../../../fun-js-lib/arr'
import { isBold, isItalic, isText, isUnderlined } from './node-type'

/**
 * @param {Span} span 
 * @param {string} fontWithoutStyles
 */
export function getStyledFont (span, fontWithoutStyles) {
  return (span.isItalic ? 'italic ' : '') +
    (span.isBold ? 'bold ' : '') +
    fontWithoutStyles
}

/**
 * @param {ChildNode} element
 * @returns {Span[]}
 */
export function breakElementIntoSpans (element) {
  if (isText(element)) {
    return [new Span(element.textContent)]
  } else {
    let spans = arrConcat(getChildren(element).map(breakElementIntoSpans))
    if (isBold(element)) {
      spans.forEach(span => span.isBold = true)
    }
    if (isItalic(element)) {
      spans.forEach(span => span.isItalic = true)
    }
    if (isUnderlined(element)) {
      spans.forEach(span => span.isUnderlined = true)
    }
    return spans
  }
}

/**
 * Breaks child nodes of `element` into spans, then concatenates them
 * @param {ChildNode} element
 */
export function breakChildrenIntoSpans (element) {
  return arrConcat(Array.from(element.childNodes).map(child =>
    breakElementIntoSpans(child)))
}

export class Span {
  /**
   * @param {string} text 
   */
  constructor (text) {
    this.text = text
    this.isBold = false
    this.isItalic = false
    this.isUnderlined = false
  }
}

function getChildren (element) {
  return Array.from(element.childNodes)
}